import DashNav3 from "../components/DashNav3";
import '../styling/NewClients.css';
import {Link} from 'react-router-dom'
import ClientList from "../components/ClientList";
import {useClientsContext} from "../hooks/useClientsContext"
import {useState} from 'react';

const NewClients = () => {

    const {clients, dispatch} = useClientsContext();
    const [searchTerm, setSearchTerm] = useState('');

    return ( 
        <div className="newclientscontainer">
            <DashNav3></DashNav3>
            <div className="newclientsright">
                <div className="newclientstop">
                <h1 className="text-3xl font-bold">Clients</h1>
                <Link to="/createclient">
                <button className="btn btn-primary" id="newclientsbutton">New Client</button>
                </Link>
                </div>
                <hr id="newline1"/>
                <div className="clientsdata">
                    <div className="clientsdatadiv">
                    <h1 className="text-2xl text-black" >All Clients</h1>
                    <div className="clientscount2">
                    {clients ? <h1 className="text-md text-black font-bold">{clients.length}</h1> : <h1 className="text-md text-black font-bold">0</h1>}
                    </div>
                    </div>

            <div className="join">
                    <div>
                    <div>
                    <input className="input input-bordered join-item" placeholder="Search" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)}/>
                    </div>
                    </div>
                    <div className="indicator">
                    <button className="btn join-item">Search</button>
                    </div>
                </div>
                </div>
                <ClientList searchTerm={searchTerm}></ClientList>
            </div>
        </div>
    );
}
 
export default NewClients;